<template>
  <div class="input_element">
    <div class="row">
      <p style="white-space: nowrap; font-weight: 600;">Contract Deployment Fee</p>
      <p style="white-space: nowrap">0.01 {{ current.ticker }}</p>
    </div>
    <div class="row">
      <p style="white-space: nowrap; font-weight: 600;">Swapping Fee</p>
      <p style="white-space: nowrap">{{ current.currentSwap }} {{ current.ticker }}</p>
    </div>
    <div class="row">
      <p style="white-space: nowrap; font-weight: 600;">Total Cost</p>
      <p style="white-space: nowrap">{{ total }} {{ current.ticker }}</p>
    </div>
    <div style="width: 100%; height: 1px; background-color: white; margin-top: 20px"/>
    <div class="row">
      <p style="white-space: nowrap; font-weight: 600;">Loan Profit</p>
      <p style="white-space: nowrap">{{ current.currentResult }} {{ current.ticker }}</p>
    </div>
  </div>
</template>

<script>
import {bus} from "@/main";

export default {
  name: "Result",
  created() {
    bus.$on('chain-changed', this.chainChanged);
    bus.$on('increased', this.increased);
    bus.$on('decreased', this.decreased);
    bus.$on('need-total', this.needTotal);
  },
  beforeDestroy() {
    bus.$off('chain-changed', this.chainChanged);
    bus.$off('increased', this.increased);
    bus.$off('decreased', this.decreased);
    bus.$off('need-total', this.needTotal);
  },
  data: function () {
    return {
      current: {
        inputValue: 5,
        ticker: "ETH",
        stepSwap: 0.0225,
        stepResult: 0.845,
        currentSwap: 0.0625,
        currentResult: 0.225,
        initialSwap: 0.0625,
        initialResult: 0.225
      },
      eth: {
        inputValue: 5,
        ticker: "ETH",
        stepSwap: 0.0225,
        stepResult: 0.245,
        currentSwap: 0.0625,
        currentResult: 0.225,
        initialSwap: 0.0625,
        initialResult: 0.225
      },
      bnb: {
        inputValue: 25,
        ticker: "BNB",
        stepSwap: 0.231,
        stepResult: 2.65,
        currentSwap: 0.156,
        currentResult: 3.25,
        initialSwap: 0.156,
        initialResult: 3.25
      }
    }
  },
  computed: {
    total: function () {
      return Math.round((this.current.currentSwap + 0.01) * 100) / 100
    }
  },
  methods: {
    chainChanged: function (chainId) {
      if (chainId == 0x1) {
        this.eth.currentSwap = this.eth.initialSwap
        this.eth.currentResult = this.eth.initialResult
        this.current = this.eth
      } else if (chainId == 0x38) {
        this.bnb.currentSwap = this.bnb.initialSwap
        this.bnb.currentResult = this.bnb.initialResult
        this.current = this.bnb
      }
    },
    increased: function () {
      this.current.currentSwap = Math.round((this.current.currentSwap + this.current.stepSwap) * 100) / 100
      this.current.currentResult = Math.round((this.current.currentResult + this.current.stepResult) * 100) / 100
    },
    decreased: function () {
      this.current.currentSwap = Math.round((this.current.currentSwap - this.current.stepSwap) * 100) / 100
      this.current.currentResult = Math.round((this.current.currentResult - this.current.stepResult) * 100) / 100
    },
    needTotal: function () {
      bus.$emit('get-total', this.total)
    }
  }
}
</script>

<style scoped>
.input_element {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  padding: 20px;

  border-radius: 20px;
  border: 1px solid rgb(44, 47, 54);
  background-color: rgb(33, 36, 41);

  font-size: 15px;
  color: rgb(255, 255, 255);
}

.row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
}
</style>